namespace Portico.Models {
    export class ProgramCardTypeInfo {
        public cardTypes: number[];
        public surveyId: number;
        public questionId: number;

        constructor() {
            this.cardTypes = [];
            this.surveyId = null;
            this.questionId = null;
        }
    }
}